import * as React from 'react'
// @ts-ignore
import IconCaret  from '../../assets/caret-down-svg.svg'
import { Props } from './types'

import './styles.scss'

const IconCaret = ({ style }: any) => {
  return (
    <svg
      width="64.000000pt"
      height="64.000000pt"
      viewBox="0 0 64.000000 64.000000"
      preserveAspectRatio="xMidYMid meet"
      style={style}
    >
      <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)"
         fill="#000000" stroke="none">
        <path d="M12 488 c-7 -7 -12 -19 -12 -28 0 -20 300 -320 320 -320 20 0 320
        301 320 321 0 37 -16 39 -320 39 -217 0 -299 -3 -308 -12z"/>
      </g>
    </svg>
  )
}

export const Collapsible: React.FC<Required<Props>> = (props) => {
  const [isCollapsed, setCollapsed] = React.useState<boolean>(false)

  const onCollapse = () => {
    setCollapsed(!isCollapsed)
  }

  const styleBody = {
    maxHeight: isCollapsed ? '144px' : '0',
    overflow: isCollapsed ? 'scroll' : 'hidden'
  }

  return (
    <div className="collapsible">
      <div className="collapsible__header">
        <div
          className="collapsible__expand"
          onClick={onCollapse}
        >
          <IconCaret
            style={{ transform: isCollapsed ? 'rotate(180deg)' : 'rotate(0)' }}
          />
        </div>
        <p className="collapsible__label">
          {props.label}
        </p>
      </div>

      <div
        className="collapsible__body"
        style={styleBody}
      >
        { props.children }
      </div>
    </div>
  )
}
